import { animate, AnimationTriggerMetadata, state, style, transition, trigger } from '@angular/animations';

const voidStyles: { [property: string]: string | number } = {
  opacity: 0,
  left: 100,
  bottom: 0,
  transform: 'translateX(-26.5rem)',
};
const transitionDuration = 200;
const transitionCurve = 'linear';
const transitionDelay = 0;

export const hornavbarSearchAnimations: AnimationTriggerMetadata = trigger(
  'hornavbarSearch',
  [
    state('void', style(voidStyles)),

    transition(':enter', [
      animate(`${transitionDuration}ms ${transitionDelay}ms ${transitionCurve}`),
    ]),

    transition(':leave', [
      animate(`${transitionDuration}ms ${transitionDelay}ms ${transitionCurve}`),
    ]),

  ],
);
